import { computed, defineComponent } from 'vue'
import type { ExtractPropTypes, CSSProperties } from 'vue'

export const itemProps = () => ({
  flexBasic: String,
})

export type ItemProps = Partial<ExtractPropTypes<ReturnType<typeof itemProps>>>

export default defineComponent({
  name: 'OFlexitem',
  inheritAttrs: false,
  props: itemProps(),
  setup(props, { slots, attrs, emit, expose }) {
    const style = computed(() => {
      const itemStyle: CSSProperties = {}

      if (props.flexBasic !== 'need' && props.flexBasic !== 'fill') {
        itemStyle['flex'] = `0 0 ${props.flexBasic}`
      }

      return itemStyle
    })

    const classes = computed(() => {
      let flexClass = 'orion-flexitem-fill'
      if (props.flexBasic) {
        if (props.flexBasic == 'need') {
          flexClass = 'orion-flexitem-auto'
        } else if (props.flexBasic !== 'need' && props.flexBasic !== 'fill') {
          flexClass = 'orion-flexitem-fixed'
        }
      }

      return ['orion-flexitem', flexClass]
    })

    return () => {
      const children = slots.default?.()

      return (
        <div class={[classes.value, attrs.class]} style={[style.value, attrs.style as CSSProperties]}>
          {children}
        </div>
      )
    }
  },
})
